import 'tslib';
import * as React from 'react';
import '@invitae/cms-blocks';

var ContentfulComponentMapContext = React.createContext({});

export { ContentfulComponentMapContext };
//# sourceMappingURL=index.esm.js.map
